export interface SalesOrderPeriodState {
  salesOrderPeriods?: SalesOrderPeriod[];
}

export enum PeriodType {
  GBM = 'GBM',
  Fertilization = 'Fertilization',
}

export interface SalesOrderPeriod {
  id: number;
  year: number;
  periodType: PeriodType;
  deliverBefore: string;
  name: string;
  orderReceivedBefore: string;
  periodNumber: number;
  startDispatchFrom: string;
  valutaMoment: string;
}
